import { render, staticRenderFns } from "./contact__Call.vue?vue&type=template&id=0b596ab8&"
import script from "./contact__Call.vue?vue&type=script&lang=js&"
export * from "./contact__Call.vue?vue&type=script&lang=js&"
import style0 from "./contact__Call.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCheckbox,VDialog,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b596ab8')) {
      api.createRecord('0b596ab8', component.options)
    } else {
      api.reload('0b596ab8', component.options)
    }
    module.hot.accept("./contact__Call.vue?vue&type=template&id=0b596ab8&", function () {
      api.rerender('0b596ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/contact__Call.vue"
export default component.exports